import { type AxiosResponse } from 'axios'
import { type PaymentSettings } from 'digital-settings/common/entities'
import { type PartialDeep } from 'type-fest'
import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { queryClient, useMutationRequest } from '~/ui/hooks/utils/service/use-query-request'

async function patchPaymentSettings(
  paymentProfileId: string,
  paymentSettings: PartialDeep<PaymentSettings>
): Promise<AxiosResponse<PaymentSettings>> {
  return httpClientVendasCoreBff<PaymentSettings>({
    url: `/v1/payment-profile/${paymentProfileId}/payments-settings`,
    method: 'PATCH',
    data: paymentSettings
  })
}

export function usePatchPaymentSettings(paymentProfileId: string) {
  return useMutationRequest(
    ['patchPaymentSettings', paymentProfileId] as const,
    (paymentSettings: PartialDeep<PaymentSettings>) => patchPaymentSettings(paymentProfileId, paymentSettings),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['useGetPaymentsSettings', paymentProfileId] })
      }
    }
  )
}
